/** Page 01 — Fig. 1, the strategic roadmap: what each age unlocks across the five stages of the operation. */
export interface RoadmapLane {
  name: string;
  who: string;
  bronze: readonly string[];
  silver: readonly string[];
  golden: readonly string[];
}

export const ROADMAP_CAPTION = 'Fig. 1 — Strategic roadmap';
export const ROADMAP_TITLE = 'What each age unlocks — across the five stages of the operation';
export const ROADMAP_COLUMNS = ['Bronze · 2026', 'Silver · 2027', 'Golden · 2028'] as const;

export const ROADMAP: readonly RoadmapLane[] = [
  {
    name: 'Getting the vehicles',
    who: 'PP · LOG',
    bronze: ['4-model relaunch: Tiggo 9/7 PHEV, 4 HEV, Himla', 'Official price lists — dated, traceable', 'Ordering, shipping, storage & PDI locked'],
    silver: [
      '15 variants live — a launch every quarter',
      '600 units ordered early: availability never breaks momentum',
      'Channel pricing in force: retail · fleet · network',
    ],
    golden: ['Full catalog depth across 6 segments', 'Accessories pipeline becomes its own business', 'Order book tuned by 3 years of sales data'],
  },
  {
    name: 'Selling the vehicles',
    who: 'MRK · SAL · CX',
    bronze: [
      '568 units on a per-VIN plan — every unit named to a channel',
      'Brand equity rebuilt from zero',
      'Core locations + call channels activated',
      'Deep conversations with every customer',
    ],
    silver: [
      '1,473 units; fleet engine at 30–35% across six sectors',
      'Real stories of real customers carry the brand',
      'Flagship showroom aligned with the X-Series',
    ],
    golden: [
      '2,407 units — a top-5 Chinese brand',
      'Referrals and repeat buyers become the first channel',
      'Waiting lists on launch models, not discounts',
    ],
  },
  {
    name: 'Servicing the vehicles',
    who: 'SER/BP',
    bronze: ['Coverage matched to every vehicle sold', 'Free-warranty offers + fleet support', 'Appointment availability — booked, not awaited'],
    silver: ['Value-add menu: financing, insurance, protection', 'Capacity and coverage grow ahead of the ramp'],
    golden: [
      'Aftersales a profit center in its own right',
      'Mobile units + partners close the coverage map',
      'Retention: every sold car returns for its 3rd service',
    ],
  },
  {
    name: 'Spare parts',
    who: 'SP',
    bronze: ['Formula-driven stock for every vehicle in operation', 'Kept-items list + minimum levels enforced'],
    silver: ['Branches + sub-dealers extend availability', 'Counter sales grow beside workshop demand'],
    golden: ['Top-1 availability and pricing, held', 'Group-level parts play across Chery-family brands'],
  },
  {
    name: 'Finance & accounting',
    who: 'FA',
    bronze: ['One P&L across vehicles, parts, service', 'Cash discipline from day one'],
    silver: ['Volume at a profit — margin control as spend scales', 'Collections keep pace: 90-day ceiling'],
    golden: ['Positive P&L — the corner held', 'Working capital self-funding through the cycle'],
  },
];
